import { active } from './active';
import { IUserDetail } from 'shared/models/user';
import { EClickPosition } from 'shared/constant';
import { TComment } from 'shared/models/comment';
import { TArticleDetail } from 'shared/models/article';
import { SHARING_DEFAULT_PID } from '~/utils/active';

export const activeToUser = (user: IUserDetail, clickPosition: EClickPosition, clickId?: string): void => {
  active({
    schemaOption: {
      pid: SHARING_DEFAULT_PID,
      pageType: 'user',
      userId: user.userId,
    },
    ampExtraOption: {
      clickPosition,
      clickId,
    },
  });
};

export const activeToArticleAuthor = (
  article: TArticleDetail,
  clickPosition: EClickPosition,
  clickId?: string,
): void => {
  active({
    schemaOption: {
      pid: SHARING_DEFAULT_PID,
      pageType: 'user',
      userId: article.author.userId,
    },
    ampExtraOption: {
      clickPosition,
      clickId,
    },
  });
};

export const activeToCommentAuthor = (comment: TComment, clickPosition: EClickPosition, clickId?: string): void => {
  active({
    schemaOption: {
      pid: SHARING_DEFAULT_PID,
      pageType: 'user',
      userId: comment.author.userId,
    },
    ampExtraOption: {
      clickPosition,
      clickId,
    },
  });
};
